'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _idGen = require('../../utils/idGen');

var _idGen2 = _interopRequireDefault(_idGen);

var _ = require('../');

var _AccordionWrapper = require('./AccordionWrapper');

var _AccordionWrapper2 = _interopRequireDefault(_AccordionWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Accordion = function (_React$Component) {
  _inherits(Accordion, _React$Component);

  function Accordion() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Accordion);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Accordion.__proto__ || Object.getPrototypeOf(Accordion)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      expanded: _this.props.expanded || _this.props.defaultExpanded || false
    }, _this.id = _this.props.id || (0, _idGen2.default)('expander-details'), _this.toggle = function () {
      var _this$props = _this.props,
          controlledExpanded = _this$props.expanded,
          onChange = _this$props.onChange;
      var expanded = _this.state.expanded;

      if (onChange) {
        onChange(!expanded);
      }
      if (controlledExpanded === undefined) {
        _this.setState({
          expanded: !expanded
        });
      }
    }, _this.componentWillReceiveProps = function (_ref2) {
      var controlledExpanded = _ref2.expanded;

      if (controlledExpanded !== undefined) {
        _this.setState({
          expanded: controlledExpanded
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Accordion, [{
    key: 'render',
    value: function render() {
      var id = this.id;
      var _props = this.props,
          children = _props.children,
          title = _props.title,
          className = _props.className,
          listItem = _props.listItem,
          titleHref = _props.titleHref;
      var expanded = this.state.expanded;

      var accordionClassName = (0, _classnames2.default)('luna-accordion', className, {
        'is-open': expanded
      });
      return _react2.default.createElement(
        _AccordionWrapper2.default,
        { className: accordionClassName, listItem: listItem },
        _react2.default.createElement(
          'div',
          { className: 'luna-accordion__summary', onClick: this.toggle },
          _react2.default.createElement(
            'h5',
            { className: 'luna-accordion__heading' },
            _react2.default.createElement(
              'button',
              {
                className: 'luna-accordion__action',
                'aria-expanded': expanded,
                'aria-controls': id
              },
              _react2.default.createElement(
                'span',
                { className: 'luna-accordion__title' },
                titleHref ? _react2.default.createElement(
                  'a',
                  { href: titleHref },
                  title
                ) : title
              ),
              _react2.default.createElement(_.Icon, { name: expanded ? 'chevron-up' : 'chevron-down' })
            )
          )
        ),
        expanded && _react2.default.createElement(
          'div',
          {
            className: 'luna-accordion__details',
            'aria-hidden': !expanded,
            id: id
          },
          children
        )
      );
    }
  }]);

  return Accordion;
}(_react2.default.Component);

Accordion.propTypes = {
  title: _propTypes2.default.string.isRequired
};


Accordion.propTypes = {
  titleHref: _propTypes2.default.string,
  title: _propTypes2.default.string,
  expanded: _propTypes2.default.bool,
  defaultExpanded: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
  listItem: _propTypes2.default.bool
};

exports.default = Accordion;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Accordion/Accordion.js